export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.provide('getTransmissionLabel', (label) => {
        if (label == 'AT') {
            return 'Автомат'
        }
        if (label == 'MT') {
            return 'Механика'
        }
    })
})